import { Autocomplete, TextField } from "@mui/material";
import InputBox from "./InputBox";
import { PField } from "./NestedField";
import { fieldHasError, requiredValidator } from "./validator";

export default function AutocompleteInput({ name, label, required, helperText, initialValue, sx, children, freeSolo, ...props }) {
    return (
        <InputBox sx={sx}>
            <PField name={name} initialValue={initialValue} validate={required ? requiredValidator : null}>
                {(fieldProps) => {
                    const hasError = fieldHasError(fieldProps.meta);

                    return (
                        <Autocomplete
                            freeSolo={freeSolo}
                            sx={{ flex: 1 }}
                            renderInput={(params) => (
                                <TextField
                                    label={label}
                                    required={required}
                                    error={hasError}
                                    helperText={hasError ? fieldProps.meta.error : helperText}
                                    variant="standard"
                                    onChange={(event, value) => {
                                        if (freeSolo) {
                                            fieldProps.input.onChange(event.target.value);
                                        }
                                    }}
                                    {...params}
                                />
                            )}
                            {...fieldProps.input}
                            {...props}
                            onChange={(event, value) => {
                                // Necessário para passar os valores do MUI para o Final Form imediatamente.
                                fieldProps.input.onChange(value);
                            }}
                        />
                    );
                }}
            </PField>
        </InputBox>
    );
}
